<div class="flex h-screen flex-row">
  <!-- Left Panel -->
  <div class="flex w-full flex-col px-8 sm:px-16 lg:w-1/2">
    <!-- Logo fixado no topo -->
    <div class="mx-auto flex w-[399px] max-w-md justify-start py-8 pb-0">
      <app-logo />
    </div>

    <!-- Formulário centralizado -->
    <div class="flex h-screen items-center justify-center">
      <div class="animate-fade-in flex flex-col items-center justify-center gap-6">
        <app-icon name="blocked" size="6em" />
        <div class="flex flex-col items-center justify-center">
          <p class="text-2xl font-bold text-content-secondary">Oops! Acesso Negado.</p>
          <p class="text-center text-base text-gray-400">Você não tem permissão para este recurso.</p>
        </div>
        <button (click)="onBack()" appButton variant="outline">Voltar</button>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="relative hidden w-full items-center justify-center bg-brand-gradient lg:flex lg:w-3/4">
    <div class="absolute inset-0 bg-cover bg-center" style="background-image: url('assets/right-column.png')"></div>
  </div>
</div>
